module.exports = __webpack_public_path__ + "static/media/simplifyingBrsrReport.8ddff308.svg";